import React from 'react';

import d2dBlack from '@assets/img/icons/d2d-black.png';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    guidance: () => (
      <>
        ラベル指導
        <br />
        Step 1.「印刷」ボタンを押して印刷してください。A4普通紙で印刷されたラベルのみ有効です。
        <br />
        Step 2.印刷したレベルは点線に添ってお切りください。
        <br />
        <br />
        打印方法
        <br />
        Step
        1.点击该页面上蓝色的「印刷」按钮，打印该页面。（打印时，为了避免二维码过小难以扫描，建议用A4或以上尺寸打印。）
        <br />
        Step
        2.从打印下来的纸张中，沿虚线剪下有效内容，将虚线内部的内容贴在需要发送的物品外箱侧面。粘贴时，请勿遮盖住其他重要信息。
        <br />
      </>
    ),
    print: '印刷',
  },
});

export interface BarcodeLabelProps {
  d2dNo: string;
  barcodeImgSrc: string;
  qrcodeImgSrc: string;
  createdAt?: string;
}

export const BarcodeLabel: React.FC<BarcodeLabelProps> = (props) => {
  const { d2dNo, createdAt, barcodeImgSrc, qrcodeImgSrc } = props;
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.container}>
      <div className={classes.barcodeBox}>
        <img src={d2dBlack} alt="d2d" />
        <div className={classes.barcodeUrl}>https://d2dasia.com</div>
        <div className={classes.barcodeLinkBox}>
          <div className={classes.barcode} dangerouslySetInnerHTML={{ __html: barcodeImgSrc }} />
          <div className={classes.qrcode} dangerouslySetInnerHTML={{ __html: qrcodeImgSrc }} />
        </div>
        <div className={classes.hbl}>HBL NO.</div>
        <div className={classes.num}>{d2dNo}</div>
        <div className={classes.barcodeUrl} />
      </div>
      <div className={classes.createBox}>
        <div className={classes.createTitle}>
          Created at:
          {createdAt}
        </div>
        <a onClick={window.print} className={classes.printBtn}>
          {strings.print}
        </a>
        <div />
      </div>
      <div className={classes.guidance}>{strings.guidance()}</div>
    </div>
  );
};

const useStyles = makeMuiStyles((theme, common) => {
  return {
    container: {
      ...common.flexColumn,
      margin: 20,
      width: 335,
    },
    barcodeBox: {
      ...common.normalText,
      ...common.textAlignCenter,
      width: 335,
      border: '1px dashed #000000',
      boxSizing: 'border-box',
      padding: '20px 18px',
    },
    barcodeUrl: {
      paddingBottom: 12,
      borderBottom: '3px double #000000',
    },
    createBox: {
      ...common.smallerText,
      ...common.flexInline,
      ...common.justifyBetween,
      marginTop: 12,
    },
    guidance: {
      ...common.smallerText,
      marginTop: 30,
    },
    hbl: {
      ...common.normalText,
      textAlign: 'left',
      ...common.fontWeight500,
    },
    num: {
      ...common.largeText,
      ...common.fontWeight800,
    },
    barcodeLinkBox: {
      ...common.flexCenter,
      padding: '0 10px',
    },
    createTitle: {
      flex: 1,
    },
    printBtn: {
      ...common.baseButton,
      color: theme.palette.primary.main,
    },
    barcode: {
      '& svg': {
        marginTop: 20,
      },
    },
    qrcode: {},
  };
});
